module.exports = __webpack_public_path__ + "assets/b79c05879a0a2ceb72ea3b1167add096.mp3";